import { useCallback, useEffect, useState } from 'react';
import Checkbox from 'src/components/atoms/checkbox/checkbox';
import Modal from 'src/components/atoms/modal/modal';
import { Role } from 'src/models/user.model';
import { RootState, useAppDispatch, useAppSelector } from 'src/reducers';
import { getRoles } from 'src/reducers/roles.reducer';
import { updateCommissionRoles } from 'src/reducers/updates-commission-relations.reducer';
import styles from '../commissions.module.scss';
import { rolesDefaultParams } from 'src/utils/pagination-utils';

type Props = {
  commissionId: number;
  associatedRoles: Role[];
};

export const UpdateRolesRelations = (props: Props) => {
  const { commissionId, associatedRoles } = props;

  const dispatch = useAppDispatch();
  const [checkedRoleIds, setCheckedRoleIds] = useState<number[]>([]);

  const rolesReducer = useAppSelector((state: RootState) => state.roles);

  useEffect(() => {
    dispatch(getRoles({ pagination: rolesDefaultParams }));
  }, [dispatch]);

  useEffect(() => {
    if (associatedRoles && associatedRoles.length > 0) {
      const initialCheckedRoleIds = associatedRoles.map(role => role.id);
      setCheckedRoleIds(initialCheckedRoleIds);
    }
  }, [associatedRoles]);

  const handleCheckRole = useCallback(
    (roleId: number) => {
      if (checkedRoleIds.includes(roleId)) {
        const updatedCheckedRoleIds = checkedRoleIds.filter(id => id !== roleId);
        setCheckedRoleIds(updatedCheckedRoleIds);
      } else {
        const updatedCheckedRoleIds = [...checkedRoleIds, roleId];
        setCheckedRoleIds(updatedCheckedRoleIds);
      }

      dispatch(
        updateCommissionRoles({
          roleId,
          commissionId,
        })
      );
    },
    [checkedRoleIds, dispatch, commissionId]
  );

  return (
    <>
      <Modal.Header />
      <Modal.Body>
        <div className={styles.modalForUpdates}>
          {rolesReducer.roles.map(roleWithCapabilities => (
            <div className={styles.roleForCommissionCard} key={roleWithCapabilities.role.id}>
              <Checkbox
                checked={checkedRoleIds.includes(roleWithCapabilities.role.id)}
                onCheck={() => handleCheckRole(roleWithCapabilities.role.id)}
              />
              <div>{roleWithCapabilities.role.name}</div>
            </div>
          ))}
        </div>
      </Modal.Body>
    </>
  );
};
